import { http } from "../../../shared/api/http"
import { Certificate } from "../../../pages/profiles/types"

/* ===================== TYPES ===================== */

export type CertificateListResponse = {
  items: Certificate[]
  total: number
}

/* ===================== API ===================== */

export const listMyCertificatesApi = () => {
  return http.get<CertificateListResponse>("api/users/me/certificates")
}

export const createCertificateApi = (
  data: Omit<Certificate, "id">
) => {
  return http.post<Certificate>("api/users/me/certificates", data)
}

export const deleteCertificateApi = (id: string) => {
  return http.delete<void>(`api/users/me/certificates/${id}`)
}
